import * as React from "react";
import * as _ from "lodash";
import {translate} from 'react-i18next';
import i18n from "i18next";
import {connect} from "react-redux";
import {Button, Checkbox, Dropdown, DropdownItemProps, Icon} from 'semantic-ui-react';
// reducer
import {ITranslatedComponent, ITypefamilyMap} from "../../../redux/reducers/generalReducer";
import DependentSelect, {EDirection, IDependentSelectDataAdapter, IDependentSelectFilter} from "../../../components/DependentSelect";
import {ModelyearDto, TypefamilyDto, CnrDto, ResourceListOfModelyearDto} from "../../../services/Client";
import ColumnFactory from "../../../services/ColumnFactory";
import {Table} from "semantic-ui-react";
import deepEqual from 'deep-equal';
import {EActiveMarketKey, PropertiesKey} from "../OptionsViewUtils";
import {compose} from "redux";
import {selectUserCnrs, selectUserPSLModelyears, selectUserTypefamiliesMap} from "../../../redux/selectors";
import {IReduxState} from "src/redux/IReduxState";
class Adapter<TDto extends object> implements IDependentSelectDataAdapter {
    constructor(private adapter: PslSelect, private key: string) {
    }
    getKey(): string {
        return this.key;
    }
    getData(): TDto[] {
        return this.adapter.getData(this.getKey()) as TDto[];
    }
    getFilter(): IDependentSelectFilter {
        return this.adapter.getFilter();
    }
    setFilter(filter: IDependentSelectFilter): Promise<void> {
        return this.adapter.setFilter(this.getKey(), filter);
    }
}

class MJA extends Adapter<ModelyearDto> {
    renderer = (dto: ModelyearDto) => ColumnFactory.mj2str(dto);
}

class TFA extends Adapter<TypefamilyDto> {
    renderer = (dto: TypefamilyDto) => i18n.t("GLOBAL:" + dto.key);
}

class CNA extends Adapter<CnrDto> {
    renderer = (dto: CnrDto) => i18n.t("GLOBAL:" + dto.cnr);
}

interface IMapStateToProps {
    userPSLModelyears: ResourceListOfModelyearDto;
    userCnrs: CnrDto[];
    userTypefamiliesMap: ITypefamilyMap;
}

export interface IPSLSel {
    modelyear?: ModelyearDto;
    typefamily?: TypefamilyDto;
    cnr?: CnrDto;
}

interface IPslSelectProps extends IMapStateToProps, ITranslatedComponent {
    activeMarket?: EActiveMarketKey;
    value?: IPSLSel;
    onChange?(psl: IPSLSel): void;
    validateInput?(psl: IPSLSel): boolean;
    userPSLModelyears: ResourceListOfModelyearDto;
    userCnrs: CnrDto[];
    userTypefamiliesMap: ITypefamilyMap;
    isNewGridTable: boolean;
    onNewGridTableChange: (isNewGridTable: boolean) => void;
}

interface PslFilter extends IDependentSelectFilter, IPSLSel {
}

interface IPslSelectState {
    inputValid: boolean;
}

export interface IPslSelection {
    modelyear: ModelyearDto;
    typefamily: TypefamilyDto;
    cnr: CnrDto;
    isNewTable: boolean;
}

class PslSelect extends React.Component<IPslSelectProps, IPslSelectState> {
    adapters: Array<IDependentSelectDataAdapter> = [];
    filter: PslFilter = {};
    constructor(props: IPslSelectProps) {
        super(props);
        const inputValid = props.value !== undefined && (!props.validateInput || props.validateInput(props.value));
        this.state = {
            inputValid
        };
        if (props.value) {
            Object.assign(this.filter, props.value);
        }

        this.adapters = [new CNA(this, "cnr"), new MJA(this, "modelyear"), new TFA(this, "typefamily")];

        this.setFilterIntern = this.setFilterIntern.bind(this);
    }

    private setFilterIntern(filter: PslFilter) {
        this.filter = filter;
        const inputValid = !this.props.validateInput || this.props.validateInput(filter);
        this.setState({inputValid}, () => {
            if (this.props.onChange) {
                this.props.onChange(filter);
            }
        });
    }
    componentDidMount(): void {
        setTimeout(
            () => {
                this.setState({inputValid: this.state.inputValid});
            },
        );
    }

    componentWillReceiveProps(newProps: IPslSelectProps) {
        const checkState = ['userTypefamiliesMap'];
        if (!deepEqual(newProps.value, this.props.value, {strict: true})) {
            this.setFilterIntern(newProps.value as PslFilter);
        }
        // @ts-ignore
        if (_.some(checkState, p => this.props[p] !== newProps[p])) {
            const newFilter = {...this.filter};
            const {modelyear, typefamily} = newFilter;
            if (modelyear && typefamily) {
                const typefamilies = newProps.userTypefamiliesMap[modelyear.mj1];
                if (typefamilies && typefamilies.elements) {
                    newFilter.typefamily = typefamilies.elements.find((tf) => typefamily.typefamily === tf.typefamily);
                    this.setFilterIntern(newFilter);
                }
            }
        }
    }

    /**
     *
     * The select is dependent.
     * Select order: CNR -> Model year -> Typefamily
     */
    getData(key: string): object[] {
        const {userPSLModelyears, userCnrs, userTypefamiliesMap} = this.props;
        const {modelyear, cnr} = this.filter;
        switch (key) {
            case "modelyear":
                if (cnr) {
                    return userPSLModelyears.elements ? userPSLModelyears.elements : [];
                }
                else {
                    return [];
                }
            case "typefamily":
                if (modelyear) {
                    const typefamilies = userTypefamiliesMap[modelyear.mj1];
                    return !typefamilies || !typefamilies.elements ? [] : typefamilies.elements;
                }
                else {
                    return [];
                }
            case "cnr":
                if (userCnrs) {
                    if (this.props.activeMarket === EActiveMarketKey.BasicMarketActiveKey) {
                        return userCnrs.filter((cnrDto: CnrDto) => cnrDto.cnr === PropertiesKey.BasicMarketCnrKey);
                    }
                    else if (this.props.activeMarket === EActiveMarketKey.SpecificMarketActiveKey) {
                        return userCnrs.filter((cnrDto: CnrDto) => cnrDto.cnr !== PropertiesKey.BasicMarketCnrKey);
                    }
                    else {
                        return userCnrs;
                    }
                }
                else {
                    return [];
                }
            default:
                return [];
        }
    }
    getFilter(): IDependentSelectFilter {
        return this.filter;
    }
    setFilter(key: string, filter: PslFilter): Promise<void> {
        const newFilter = {...filter};

        switch (key) {
            case "modelyear":
                const {modelyear, typefamily} = filter;
                if (modelyear) {
                    const typefamilies = this.props.userTypefamiliesMap[modelyear.mj1];
                    if (typefamily && typefamilies && typefamilies.elements) {
                        newFilter.typefamily = typefamilies.elements.find((tf) => typefamily.typefamily === tf.typefamily);
                    }
                }
                break;
            default:
                break;
        }
        this.setFilterIntern(newFilter);
        return Promise.resolve();
    }

    render() {
        const {
            t,
            activeMarket,
        } = this.props;

        const placeholders = [
            t("C_NUMBER"),
            t("MODELYEAR"),
            t("TYPEFAMILY")
        ];

        const cont = (
            <DependentSelect
                title={t("SELECT_PSL")}
                direction={EDirection.Vertical}
                placeholders={placeholders}
                dataAdapters={this.adapters}
                value={this.filter}
                boldFeature={true}
                activeMarket={activeMarket}
            />
        );
        return (
            <Table>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell negative={!this.state.inputValid}>
                            {cont}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                            <Checkbox
                                checked={this.props.isNewGridTable}
                                label="Load with new draft Grid table (Beta Version)"
                                onChange={(event, data: any) => this.props.onNewGridTableChange(data.checked)}
                            />
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    userPSLModelyears: selectUserPSLModelyears(state),
    userCnrs: selectUserCnrs(state),
    userTypefamiliesMap: selectUserTypefamiliesMap(state)
});

export default compose<React.ComponentType<any>>(
    translate("OPTIONS_VIEW"),
    connect<IMapStateToProps>(mapStateToProps)
)(PslSelect);



// WEBPACK FOOTER //
// ./src/views/OptionsView/PSL/PslSelect.tsx